import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import TopTabbar from "../components/partials/TopTabbar";
import Header from "../components/partials/Header";
import Footer from "../components/partials/Footer";
import LoadingSpinner from '../utils/LoadingSpinner';

const SettingsPage = () => {
    const navigate = useNavigate();
    const [isPageLoading, setIsPageLoading] = useState(true);

    useEffect(() => {
        // Simuler un chargement de 2 secondes
        setTimeout(() => {
            setIsPageLoading(false);
        }, 2000);
    }, []);

    if (isPageLoading) {
        return <LoadingSpinner isVisible={true} loadingText="Chargement des paramètres..." />;
    }

    return (
        <>
            <div className="d-flex flex-column vh-100">
                <div className="flex-grow-1 overflow-y-scroll">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        <div className="verify-number-main">
                            <TopTabbar />
                            <Header />
                            <div className="verify-number-top">
                                <div className="container">
                                    <div className="verify-number-top-content">
                                        <div className="header-title mt-35" style={{
                                            marginTop: '30px',
                                            fontWeight: 'bold',
                                            fontSize: '24px',
                                            color: 'white',
                                        }}>
                                            <i className="fa-sharp-duotone fa-solid fa-gears me-3"></i>
                                            <span>Paramétrages</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="verify-number-bottom" id="bank-and-card-main">
                                <div className="verify-number-bottom-wrap">
                                    <div className="verify-number-content">
                                        <div className="transfer-to-bank">
                                            {/* Bank Settings */}
                                            <div
                                                className="transfer-first clickable"
                                                onClick={() => navigate('/banks')}
                                            >
                                                <div className="bank-img">
                                                    <img src="assets/images/transfer-to-bank/bank1.svg" alt="bank-icon" />
                                                </div>
                                                <div className="bank-details">
                                                    <h2>Paramétrages des Banques</h2>
                                                </div>
                                            </div>
                                            {/* Wallet Settings */}
                                            <div
                                                className="transfer-first clickable"
                                                onClick={() => navigate('/wallets')}
                                            >
                                                <div className="bank-img">
                                                    <img src="assets/images/paybill/bill-4.svg" alt="bank-icon" />
                                                </div>
                                                <div className="bank-details">
                                                    <h2>Paramétrages des Wallets</h2>
                                                </div>
                                            </div>
                                            {/* General Settings */}
                                            <div
                                                className="transfer-first clickable"
                                                onClick={() => navigate('/general-settings')}
                                            >
                                                <div className="bank-img">
                                                    <img src="assets/images/paybill/bill-6.svg" alt="bank-icon" />
                                                </div>
                                                <div className="bank-details">
                                                    <h2>Paramétrages Généraux des Taux</h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SettingsPage;
